import React from 'react';
import { connect } from 'react-redux';
import Spin from '../../components/loading';

import Pagination2 from '../../components/Pagination2';
import FinancialTransactionsTable from './Table';
import FinancialTransactionsFilter from './Filter';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';

import * as financialTransactionsActions from '../../redux/financialTransactions/actions';
import submitForm from '../../utils/submitForm';

class FinancialTransactions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      errorText: locales('errors.default'),
      errorFlag: false,
      itemsPerPage: 10,
      sortType: 'asc',
      sortBy: 'createdAt'
    };
  }

  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  applyFilters = event => {
    const queryString = submitForm(event);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllFinancialTransactions(searchQuery);
    });
  };

  sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  onPageChanged = data => {
    const { currentPage } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllFinancialTransactions(query);
    });
  };

  render() {
    const { loading, message, failed, error, financialTransactionsList } = this.props;
    const { totalRecords } = this.props.financialTransactions;
    const { currentPage, itemsPerPage, sortType, sortName } = this.state;

    return (
      <>
        {this.state.errorFlag && this.handleAlert()}
        <section id="financial-transactions-section" className="p-1 col-12">
          <h3 className="text-muted py-4">
            <div className="text-right">{locales('titles.financial.transactions')}</div>
          </h3>
          <Spin spinning={loading}>
            <article>
              <main className="panel panel-default">
                {error ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {failed && <div className="alert alert-danger">{message}</div>}
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1" />
                      {locales('titles.financial.transaction.list')}
                    </div>

                    <div className="panel-body">
                      <FinancialTransactionsFilter
                        applyFilters={this.applyFilters}
                        filterAndSort={this.filterAndSort}
                      />

                      <FinancialTransactionsTable
                        financialTransactionsList={financialTransactionsList}
                        pageNumber={currentPage}
                        pageSize={itemsPerPage}
                        sortType={sortType}
                        sortName={sortName}
                        sortTable={this.sortTable}
                      />

                      <div className="pagination-container">
                        <Pagination2
                          totalRecords={totalRecords || 0}
                          pageLimit={itemsPerPage}
                          pageNeighbours={2}
                          onPageChanged={this.onPageChanged}
                          currentPage={this.state.currentPage}
                        />
                      </div>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    financialTransactionsList: state.financialTransactionsReducer.financialTransactionsList,
    financialTransactions: state.financialTransactionsReducer.financialTransactions || {},
    loading: state.financialTransactionsReducer.loading,
    message: state.financialTransactionsReducer.message,
    failed: state.financialTransactionsReducer.failed,
    error: state.financialTransactionsReducer.error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllFinancialTransactions: query =>
      dispatch(financialTransactionsActions.fetchAllFinancialTransactions(query))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FinancialTransactions);
